// extracted by mini-css-extract-plugin
export default {"gallery-container":"OffersGallery_gallery-container__sPayS","gallery-offer":"OffersGallery_gallery-offer__BPLxU"};